/* eslint-disable max-len */
import React, { useState, useRef, useEffect,useContext } from 'react';
// import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useLocation } from 'react-router-dom';
import { useViewOrganizationUserQuery } from '../../../../../features/organizationUserSlice';
import CustomOverLay from '../../../../../components/CustomOverLay';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { useExportSubdivisionMutation } from '../../../../../features/organizationUserSlice';
import OrganizationExport from '../../OrganizationExport';
export default function SubDivsionList({id,user_id}) {
    const location = useLocation()
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [queryParams,setQueryParams]=useState(`?page_number=1&limit=15&action=list`)
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [limit, setLimit] = useState(15);
    const [totalPageNumber, setTotalPageNumber] = useState(1);
    const {data,isFetching,isLoading,status}=useViewOrganizationUserQuery(`${id}${queryParams}`)
    const [exportSubdivision]=useExportSubdivisionMutation()
    const fetchPageAndLimit=()=>{
        const splitQuery = queryParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }

    const handlePrevClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };
    
    const handleNextClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };
    const limitArr = [15, 30, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    // useOnClickOutside(ref, () => {
    //     setIsOpen(false);
    // });

   

    function handleNoOfRowsClick(number) {
        setQueryParams(`${queryParams.split('?')[0]}?page_number=1&limit=${number}&action=list`);
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setQueryParams(`${queryParams.split('?')[0]}?page_number=${pageNum}&limit=${params.get("limit")}&action=list`);
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        const calculatedTotalPages = calculateTotalPages(data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    }, [data]);
    

    return (
        <>  
            <div className='border border-[#EDD7E1] mt-4 rounded-lg pb-2'>
                <div className='relative flex justify-between items-center py-2 pr-4 pl-[18px]'>
                    <p className='text-base font-semibold text-[#972E4C]'>Sub Division List</p>
                    <OrganizationExport 
                        exportUsers={exportSubdivision}
                        exportCols = {['ID' , 'Sub Division Name']}
                        isColumnSelect = {isColumnSelect}
                        setIsColumnSelect = {setIsColumnSelect}
                        setIsFilterOpen={()=>{}}
                        username = {false}
                        isIdexport={false}
                        user_id={user_id}
                        viewOrgUser={true}
                        TotalCount={parseInt(data?.total_count)}
                    />
                </div>
                { ((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading subdivisions list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                    <table aria-label="Outside Table" className="w-full table-fixed">
                        <thead>
                            <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                                <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        ID
                                    </span>
                                </th>
                                <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        Sub Division Name
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.data && data?.data?.length>0 && data?.data?.map((subdivision, index) => (
                        
                                <tr key={index}>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {subdivision?.sub_division_id}
                        
                                    </td>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {subdivision?.sub_division_name}
                                    </td>
                                </tr>

                            ))}
                        
                        </tbody>
                    </table>
                
                    {data && data?.total_count>15 && 
                    <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                        <p className="text-sm font-semibold text-[#687182]">
                            Total Number of Records: {data?.total_count}
                        </p>
                        <div className="flex items-center">
                            <div className={`${isColumnSelect ? 'pl-1' : 'relative pl-1'}`}>
                                <button
                                    ref={buttonRef}
                                    onClick={() => setIsOpen(!isOpen)}
                                    type="button"
                                    className="text-sm font-semibold text-[#687182] flex items-center"
                                >
                                    <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                    <span className="pl-0.5">
                                        <img
                                            src="/images/down.svg"
                                            className={`${isOpen ? "transform rotate-180" : ""}`}
                                            alt="icon"
                                            onClick={() => setIsOpen(!isOpen)}
                                        />
                                    </span>
                                </button>
                                <ul
                                    className={`absolute top-[-140px] left-0 pl-1.5 py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen ? "" : "hidden"}`}
                                    ref={dropdownRef}
                                >
                                    <li>
                                        <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                            {limitArr.map((item, index) => (
                                                <li key={index}>
                                                    <h1
                                                        onClick={() => {
                                                            setLimit(item);
                                                            setIsOpen(false);
                                                            handleNoOfRowsClick(item);
                                                        }}
                                                        className={`text-base font-normal cursor-pointer ${
                                                            item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                        } mb-[16px]`}
                                                    >
                                                        {item}
                                                    </h1>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="flex items-center ml-5">
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                    onClick={handlePrevClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/left.svg" alt="icon" />
                                </button>
                                <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                    <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                                </p>
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                    onClick={handleNextClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/right.svg" alt="icon" />
                                </button>
                            </div>
                        </div>
                    </div>}
                </>}
            </div>
            
        </>
    )
}
